module.exports = __webpack_public_path__ + "static/media/check-mark-button-mobile.c831b814.svg";